module.exports = __webpack_public_path__ + "images/feature/file-multi-version-3-4f440109058cceb244645ea70a8396f7.jpg";